<template>
  <div class="agent-ad-revenue">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>广告收入</span>
        <div class="filter-bar">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :clearable="false"
            class="filter-daterange"
            @change="fetchOverview"
          />
          <date-range-quick
            :value="dateRange"
            :presets="presets"
            @input="onRangeChange"
          />
        </div>
      </div>
      <div class="metric-wrap" v-loading="loading">
        <div class="metric">
          <div class="label">预估收益</div>
          <div class="value">¥ {{ formatMoney(overview.estimateRevenue) }}</div>
        </div>
        <div class="metric">
          <div class="label">收益</div>
          <div class="value">¥ {{ formatMoney(overview.revenue) }}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from '@/utils/http'
import DateRangeQuick from '@/components/DateRangeQuick.vue'
import {
  AGENT_DATE_RANGE_PRESETS,
  getTodayRange
} from '@/utils/dateRange'

export default {
  name: 'AgentAdRevenue',
  components: { DateRangeQuick },
  data() {
    return {
      loading: false,
      dateRange: getTodayRange(),
      presets: AGENT_DATE_RANGE_PRESETS,
      overview: {
        estimateRevenue: 0,
        revenue: 0
      }
    }
  },
  created() {
    this.fetchOverview()
  },
  methods: {
    onRangeChange(range) {
      this.dateRange = range
      this.fetchOverview()
    },
    async fetchOverview() {
      if (!this.dateRange || this.dateRange.length < 2) return
      this.loading = true
      try {
        const result = await get('/admin/dashboard/takuOverview', {
          startTime: this.dateRange[0],
          endTime: this.dateRange[1]
        })
        const data = (result && result.data) || {}
        this.overview = {
          estimateRevenue: data.estimateRevenue || 0,
          revenue: data.revenue || 0
        }
      } catch (e) {
        this.$message.error((e && e.message) || '加载广告收入失败')
      } finally {
        this.loading = false
      }
    },
    formatMoney(v) {
      const n = Number(v) || 0
      return n.toFixed(2)
    }
  }
}
</script>

<style scoped>
.agent-ad-revenue {
  padding: 4px;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.filter-daterange {
  width: 360px;
  max-width: 100%;
}
.metric-wrap {
  min-height: 88px;
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}
.metric {
  background: #f8fafc;
  border-radius: 8px;
  padding: 20px 24px;
  flex: 1 1 240px;
  max-width: 320px;
  text-align: center;
}
.metric .label {
  color: #64748b;
  font-size: 13px;
  margin-bottom: 8px;
}
.metric .value {
  color: #0f172a;
  font-size: 28px;
  font-weight: 600;
}
</style>
